export default [
  { value: 'Comparable', label: 'Comparable' },
  { value: 'Inferior', label: 'Inferior' },
  { value: 'Superior', label: 'Superior' },
];
  